import { createApp } from 'vue'
import { createHead } from '@unhead/vue/client'
import { createI18n } from 'vue-i18n'
import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios'
import VueCookies from 'vue-cookies'
import Notifications from '@kyvg/vue3-notification'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import moment from 'moment'
import App from './App.vue'
import routes from './router/routes'
import store from './store'
import vuetify from './plugins/vuetify'
import { createSessionPlugin } from './plugins/session'
import { createWaitPlugin } from './plugins/wait'
import { createBvModalPlugin } from './plugins/bvModal'
import { createProgressPlugin } from './plugins/progress'
import { registerBootstrapCompat } from './plugins/bootstrapCompat'
import EventBus from './utils/eventBus'
import en from './lang/locale/en.json'
import ja from './lang/locale/ja.json'
import de from './lang/locale/de.json'
import MultiSelect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css'
import AIFormBuilderChatPanel from './components/AIFormBuilder/ChatPanel.vue'
import VueProgressBar from './components/compat/VueProgressBar.vue'
import BackToTop from './components/compat/BackToTop.vue'
import VueDropzone from './components/compat/VueDropzone.vue'
import VLazyImage from './components/compat/VLazyImage.vue'
import Verte from './components/compat/Verte.vue'
import ImageUploader from './components/compat/ImageUploader.vue'
import Editor from '@tinymce/tinymce-vue'
import { configure } from 'vee-validate'
import { createMetaInfoMixin } from './plugins/metaInfoCompat'
import { createAwnCompatPlugin } from './plugins/awnCompat'
import { createVeeValidateV2CompatPlugin } from './plugins/veeValidateV2Compat'
import { createVuebarCompatPlugin } from './plugins/vuebarCompat'
import { setupRouterGuards, setRouterSession } from './router/guards'

import './assets/css/bootstrap.min.css'
import './assets/css/font-awesome.min.css'
import './assets/css/sidebar.css'

configure({
  validateOnBlur: true,
  validateOnChange: true,
  validateOnInput: false,
  validateOnModelUpdate: true
})

const i18n = createI18n({
  legacy: true,
  locale: 'en',
  messages: { de, en, ja }
})

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

setupRouterGuards(router)

const head = createHead()

const app = createApp(App)

app.config.globalProperties.moment = moment
app.config.globalProperties.$axios = axios
window.axios = axios

app.use(head)
app.use(store)
app.use(router)
app.use(i18n)
app.use(vuetify)
app.use(VueCookies, { expires: '30d' })
app.use(createSessionPlugin())
const sessionPlugin = app.config.globalProperties.$session
setRouterSession(sessionPlugin)
app.use(createVeeValidateV2CompatPlugin())
app.use(createVuebarCompatPlugin())

const savedJwt = sessionPlugin.get('jwt_token')
if (savedJwt) {
  axios.defaults.headers.common.Authorization = savedJwt
}
const savedLang = sessionPlugin.get('lang')
if (savedLang) {
  i18n.global.locale = savedLang
}

app.use(createWaitPlugin())
app.use(createBvModalPlugin())
app.use(createProgressPlugin())
app.use(Notifications)
app.use(createAwnCompatPlugin())
app.use(FloatingVue)
registerBootstrapCompat(app)
app.mixin(createMetaInfoMixin())

app.component('verte', Verte)
app.component('image-uploader', ImageUploader)
app.component('vue-dropzone', VueDropzone)
app.component('multi-select', MultiSelect)
app.component('ai-form-builder-chat-panel', AIFormBuilderChatPanel)
app.component('vue-progress-bar', VueProgressBar)
app.component('back-to-top', BackToTop)
app.component('v-lazy-image', VLazyImage)
app.component('editor', Editor)

app.provide('eventBus', EventBus)
export { EventBus }

app.mount('#app')
